/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_Big_DescInputs */



/**
* | output |
* | --- |
* | "Thirty players or more, registered in advance, spread over several rooms." |
*
* @param {Tournament_Wiz_Kind_Big_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_big_desc = /** @type {((inputs?: Tournament_Wiz_Kind_Big_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_Big_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trente joueurs ou plus, inscrits à l'avance, répartis sur plusieurs salles.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Treinta jugadores o más, inscritos con antelación, repartidos en varias salas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Trinta jogadores ou mais, inscritos com antecedência, espalhados por várias salas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trenta giocatori o più, iscritti in anticipo, distribuiti su più sale.")
	return /** @type {LocalizedString} */ ("Thirty players or more, registered in advance, spread over several rooms.")
});